export const BASE_URI = 'vertical';
export const FB_APP_ID = '358109962114282';
//export const LOCAL_URI = 'https://ilmapi.azurewebsites.net';
// export const LOCAL_URI = 'http://192.168.43.195:3000';
  export const LOCAL_URI = 'https://ilmwebappprodnew.azurewebsites.net';
